export default "__VITE_ASSET__C0y1P1Oc__"